/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_ssdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssDNA`)
};

const es_dnamw_ssdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADNss`)
};

const de_dnamw_ssdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssDNA`)
};

const nl_dnamw_ssdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssDNA`)
};

const fr_dnamw_ssdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADNsb`)
};

const it_dnamw_ssdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssDNA`)
};

const pt_br2_dnamw_ssdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssDNA`)
};

const pt_dnamw_ssdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssADN`)
};

const ja_dnamw_ssdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssDNA`)
};

const zh_dnamw_ssdna = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ssDNA（单链 DNA）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_ssdna = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_ssdna(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_ssdna", locale)
	if (locale === "en") return en_dnamw_ssdna(inputs)
	if (locale === "es") return es_dnamw_ssdna(inputs)
	if (locale === "de") return de_dnamw_ssdna(inputs)
	if (locale === "nl") return nl_dnamw_ssdna(inputs)
	if (locale === "fr") return fr_dnamw_ssdna(inputs)
	if (locale === "it") return it_dnamw_ssdna(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_ssdna(inputs)
	if (locale === "pt") return pt_dnamw_ssdna(inputs)
	if (locale === "ja") return ja_dnamw_ssdna(inputs)
	return zh_dnamw_ssdna(inputs)
};